/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    Proposal,
    ProposalFromJSON,
    ProposalFromJSONTyped,
    ProposalToJSON,
    ProposalListAllOf,
    ProposalListAllOfFromJSON,
    ProposalListAllOfFromJSONTyped,
    ProposalListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProposalList
 */
export interface ProposalList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof ProposalList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof ProposalList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Proposal>}
     * @memberof ProposalList
     */
    proposals: Array<Proposal>;
}

export function ProposalListFromJSON(json: any): ProposalList {
    return ProposalListFromJSONTyped(json, false);
}

export function ProposalListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'proposals': ((json['proposals'] as Array<any>).map(ProposalFromJSON)),
    };
}

export function ProposalListToJSON(value?: ProposalList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'proposals': ((value.proposals as Array<any>).map(ProposalToJSON)),
    };
}


